import { render, staticRenderFns } from "./reliableList.vue?vue&type=template&id=5460a4c5&scoped=true"
import script from "./reliableList.vue?vue&type=script&lang=js"
export * from "./reliableList.vue?vue&type=script&lang=js"
import style0 from "./reliableList.vue?vue&type=style&index=0&id=5460a4c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460a4c5",
  null
  
)

export default component.exports